export enum UserGender {
  MALE = 'male',
  FEMALE = 'female',
  TRANSGENDER = 'transgender',
  UNKNOWN = 'unknown',
  ANY = 'any',
}

export enum TherapistSpecialisation {
  PSYCHOLOGIST = 'psychologist',
  PSYCHOTHERAPIST = 'psychotherapist',
  PSYCHOANALYST = 'psychoanalyst',
  COACH = 'coach',
  SUPERVISOR = 'supervisor',
}

export enum SessionTypes {
  PERSONAL = 'personal',
  GROUP = 'group',
}

export type AvailableSessionTypes = {
  [key in SessionTypes]: boolean;
};

export interface UserFileResponseDto {
  filename: string;
  key: string;
}

export interface TherapistEducation {
  university: string;
  speciality: string;
  files?: UserFileResponseDto[];
}

export interface TherapistAdditionalEducation {
  course: string;
  organisation: string;
  files?: UserFileResponseDto[];
}

export interface Therapist {
  id: string;
  firstname: string;
  lastname: string;
  avatarKey: string;
  videoKey?: string;
  gender: UserGender;
  country: string;
  city: string;
  education: TherapistEducation;
  additionalEducation?: TherapistAdditionalEducation[];
  specialisation: TherapistSpecialisation[];
  availableSessionTypes: AvailableSessionTypes[];
  about: string;
  shortAbout?: string;
  workWithCouples: boolean;
  workWithFamilies: boolean;
  workWithGroups: boolean;
  workWithLgbt: boolean;
  languages: string[];
  ethnicExperienceDescription: string[];
  workWithReligions: string[];
}

export interface SessionParticipant {
  id: string;
  firstname: string;
  lastname?: string;
  avatarKey?: string;
}

export interface EnrollModalFormValues {
  day: Date;
  remind: string;
  time?: string;
}

export enum DiseasesTab {
  forSelf = 'self',
  forChild = 'child',
}
